<template>
	<information-card
		sub-title="INSTRUCTIVO"
	>
		<div slot="title" class="tw-py-6">
			<h3 class="tw-text-center text-primary uppercase">Presupuesto de Nómina</h3>
		</div>
		<div slot="content">
			<div v-html="description"></div>
			<p class="textjustify">En esta página debes ingresar los datos con los cuáles se calcularán los sueldos valorados.</p>
			<p class="textjustify">
		En la primera opción ingresa el monto (mensual o anual) del Presupuesto o costo de los sueldos al finalizar el período.
		En la siguiente opción puedes “modelar” o presupuestar un valor incrementado o modificado para observar la incidencia o
		cambio resultante en cada puesto valorado. </p>
			<p class="textjustify">Si necesitas más información puedes recurrir a tutoriales de nuestra web: www.praktiko.tech en la
				 pestaña “Comunidad” PRAKTIKO subpestaña “Entrenamiento” o escribir un email a: info@praktiko.tech </p>
		</div>
		<div slot="footer" class="tw-text-center">
			<v-btn class="custom-button black" color="primary" @click="goBack">Atrás</v-btn>
			<v-btn :disabled="!enableSave" class="custom-button" color="primary" @click="$emit('saveClick')">Guardar</v-btn>
		</div>
	</information-card>
</template>

<script>
import InformationCard from '@/modules/shared/components/content/InformationCard';


export default {
	name: 'payroll-proposal-description',
	components: { InformationCard },
	props: ['description', 'enableSave'],
	methods: {
		goBack() {
			this.goTo('job-supply-valuation-model-degrees');
		},
	},
};
</script>

<style scoped>
.textjustify {
text-align:justify;
}
</style>



// WEBPACK FOOTER //
// src/modules/job-evaluation/components/supplies/valuation-model/valuation-model/payroll-proposal/payroll-proposal-description.vue